var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-section-alert open-sans"},[_c('div',{class:'alert-icon'},[_c('q-icon',[_c('IconInformation')],1)],1),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }